import { render } from "./IncluirViagemEscala.vue?vue&type=template&id=7e0d3648"
import script from "./IncluirViagemEscala.vue?vue&type=script&lang=js"
export * from "./IncluirViagemEscala.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bhfagundes/Desktop/mobs2/operacoes-front-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__